import { Component, OnInit } from '@angular/core';

import { bl19singleQuery } from '../../../app.bl.types'

@Component({
  selector: 'bl-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  queries: bl19singleQuery[] = [
    {
      parameter: 'showOnWelcomePage',
      value: true
    },
  ]

  constructor() { }

  ngOnInit() {
  }

}
